// @ts-nocheck
// stop typescript validation for OneTrust script.
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, lighten } from '@mui/material'

// It looks silly but this is wat OneTrust prescribed
// https://community.cookiepro.com/s/article/UUID-69162cb7-c4a2-ac70-39a1-ca69c9340046?language=en_US
function reloadOTBanner() {
  const otConsentSdk = document.getElementById('onetrust-consent-sdk')
  if (otConsentSdk) {
    otConsentSdk.remove()
  }

  if (window.OneTrust != null && window.OneTrust.ToggleInfoDisplay) {
    OneTrust.Init()

    setTimeout(() => {
      OneTrust.LoadBanner()
      const toggleDisplay = document.getElementsByClassName('ot-sdk-show-settings')
      const clickHandler = function (event) {
        event.stopImmediatePropagation()
        window.OneTrust.ToggleInfoDisplay()
      }

      for (let i = 0; i < toggleDisplay.length; i++) {
        toggleDisplay[i].onclick = clickHandler
      }
    }, 500)
  }
}

// also part of one trust, needed to clear double modals from triggering
// https://community.cookiepro.com/s/article/UUID-69162cb7-c4a2-ac70-39a1-ca69c9340046?language=en_US
function clearDup() {
  const sec = document.getElementById('ot-sdk-cookie-policy')
  const tally = []
  for (let i = sec.length - 1; i >= 0; i--) {
    if (tally[sec[i].firstChild.innerText] === undefined) {
      tally[sec[i].firstChild.innerText] = 1
    } else {
      sec[i].remove()
    }
  }
}
export const OneTrustCookieSettingsButton = () => {
  const { t } = useTranslation()

  // reload OneTrust banners when rendering this button, otherwise it can't attach event handlers.
  useEffect(() => {
    reloadOTBanner() && clearDup()
  }, [])
  return (
    <Box
      sx={theme => ({
        '&>#ot-sdk-btn.ot-sdk-show-settings': {
          backgroundColor: 'White',
          color: 'primary.main',
          borderColor: 'primary.main',
          borderWidth: '1px !important',
          borderStyle: 'solid !important',
          borderRadius: '4px !important',
          transition: 'background-color .5s',
          '&:hover': {
            backgroundColor: lighten(theme.palette.primary.light, 0.9),
            color: 'primary.main'
          }
        }
      })}
    >
      {/* OptanonCookieSettingsButtonStart */}
      <button id='ot-sdk-btn' className='ot-sdk-show-settings'>
        {t('legal.cookie_settings.button_open_cookie_settings')}
      </button>
      {/* OptanonCookieSettingsButtonEnd */}
    </Box>
  )
}

export const OneTrustCookieSettingsButtonAsLink: React.FC<{ text: string }> = ({ text }) => {
  // reload OneTrust banners when rendering this button, otherwise it can't attach event handlers.
  useEffect(() => {
    reloadOTBanner() && clearDup()
  }, [])
  return (
    <Box
      sx={{
        display: 'inline',
        '&>a>#ot-sdk-btn.ot-sdk-show-settings': {
          backgroundColor: 'inherit !important',
          visibility: 'hidden !important', // we hide the actual button, and show the ':after' text
          letterSpacing: '-1rem', // we apply a negative letter spacing, it will cause the inserted on trust text to take no space
          position: 'relative !important',
          border: 'none !important',
          padding: '0px !important',
          fontSize: 'inherit !important',
          fontFamily: 'inherit !important',
          color: 'inherit !important',
          // one trust does not play nice with us and replaces any text that we put in the button.
          // we use ':after' as hack to show our own text and make the button in self invisible.
          '&:after': {
            content: `"${text}"`,
            visibility: 'visible',
            left: 0,
            whiteSpace: 'nowrap',
            letterSpacing: 'normal' // reset the spacing, this makes this text take the actual size
          }
        }
      }}
    >
      <a>
        {/* OptanonCookieSettingsButtonStart */}
        <button id='ot-sdk-btn' className='ot-sdk-show-settings' />
        {/* OptanonCookieSettingsButtonEnd */}
      </a>
    </Box>
  )
}
